export { default } from './section-message';
export { default as SectionMessageAction } from './section-message-action';
export type { Appearance, SectionMessageProps, SectionMessageActionProps } from './types';
